module.exports = __webpack_public_path__ + "img/logo.28a81174.png";